<template lang="pug">
  div(id="2GisMap", :style="mapStyles")
</template>

<script>
export default {
  props: {
    advertsList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    map: null,
    markers: null,
    mapStyles: {
      width: '100%',
      height: '650px'
    }
  }),
  mounted() {
    this.initMap([
      this.centerCoordinates.latitude,
      this.centerCoordinates.longitude
    ])
  },
  watch: {
    async advertsList(adverts) {
      if (this.markers) await this.map.removeLayer(this.markers)
      if (adverts && this.map) {
        await this.moveMap(this.centerCoordinates)
        await this.createMarkers(adverts)
        await this.map.addLayer(this.markers)
      }
    }
  },
  computed: {
    centerCoordinates() {
      return this.$store.state.coordinates
    }
  },
  methods: {
    initMap(coords) {
      const DG = require('2gis-maps')
      DG.then(() => {
        return DG.plugin(
          'https://2gis.github.io/mapsapi/vendors/Leaflet.markerCluster/leaflet.markercluster-src.js'
        )
      }).then(async () => {
        this.map = await DG.map('2GisMap', {
          center: coords,
          minZoom: 12,
          scrollWheelZoom: false
        })
        this.createMarkers(this.advertsList)
      })
    },
    createMarkers(adverts) {
      const DG = require('2gis-maps')
      this.markers = DG.markerClusterGroup({ maxClusterRadius: 20 })
      if (adverts) {
        adverts.map(advert => {
          if (advert.point !== undefined) {
            if (advert.point.latitude && advert.point.longitude) {
              this.markers.addLayer(
                DG.marker([advert.point.latitude, advert.point.longitude]).on(
                  'click',
                  () => {
                    window.open(`/advert/${advert.id}`, '_blank')
                  }
                )
              )
            }
          }
        })
      }
    },
    moveMap(coords) {
      this.map.setView([coords.latitude, coords.longitude], 10)
    }
  }
}
</script>
